$( document ).ready(function() {
  const form_id_data = $('#cb-product_form_id');
  let form_id = '';
  if (form_id_data.length !== 0) {
    form_id = form_id_data.data('product_form_id');
  }

  if (window.matchMedia("(max-width: 989px)").matches) {
    
  }
  
  $(".sample-switcher input").on("click", function() {
  
    const samples_count = parseInt($(this).data("samples-count")),
    sample_in_cart = $(".sample-switcher input").attr("data-sample-in-cart"),
    parentContainer = $(this).parents(".switcher-container").siblings(".sample-description"),
    container = $(this).parents(".free-sample-container");

    if($(this).is(":checked")) {
      parentContainer.slideDown("fast");
      $(container).find('.cb-sample-data').each(function (idxInp, dataInp) {
        $(dataInp).attr('form', form_id);
      });
      $(this).parents('.product-block-container').find('.product-block-buy-buttons span[x-show="currentVariantAvailable"]').hide()
    } else {
      parentContainer.slideUp("fast");
      $(container).find('.cb-sample-data').each(function (idxInp, dataInp) {
        $(dataInp).attr('form', 'none');
      });
      $(this).parents('.product-block-container').find('.product-block-buy-buttons span[x-show="currentVariantAvailable"]').css('display','inline')
    }
  })

if ($('.product-recommendations').length) {
  setTimeout(function(){
     $('.product-recommendations .custom-slider').slick({
          dots: false,
          infinite: false,
          speed: 300,
          slidesToShow: 3,
          slidesToScroll: 1,
          prevArrow: $('.product-recommendations .splide__arrow--prev'),
          nextArrow: $('.product-recommendations .splide__arrow--next'),
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: true
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
      });

  }, 1500)
}
  
  
  $('.blog-articles .custom-slider').slick({
          dots: false,
          infinite: false,
          speed: 300,
          slidesToShow: 3,
          slidesToScroll: 1,
          prevArrow: $('.blog-articles .splide__arrow--prev'),
          nextArrow: $('.blog-articles .splide__arrow--next'),
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: true
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
      });
  
})

